module.exports = __webpack_public_path__ + "img/Cinema4d.a54379e9.png";